import { useTranslation } from "react-i18next";
import Section from "../../Atoms/Section";
import { useEffect, useRef, useState } from "react";
import H1 from "../../Atoms/H1";
import BlueButton from "../../Atoms/BlueButton";
import * as api from '../../../api';
import Header from "../../Components/SDE24/Header";
import PopB1 from "../../Components/SDE24/Parcours/PopB1";
import Step2 from "../../Components/SDE24/Parcours/Step2";
import { Link, useNavigate } from "react-router-dom";
import { formDataToObject } from "../../Utils/Forms";
import { validateStep1BSDE2024, validateStep2SDE2024 } from "../../Utils/Validator";
import Popup from "../../Atoms/Popup";
import Spinner from "../../../Plateforme/Atoms/Spinner";

const RegisterSDE24popB = (props) => {

    const navigate = useNavigate();

    const [projets, setProjets] = useState([{
        _id: Math.random().toString(36).substr(2, 9),
        userId: null,
        title: '',
        type: '',
        country: '',
        city: '',
        description: '',
        files: [],
        validated: false
    }]);

    const [deletedProjets, setDeletedProjets] = useState([]);
    const [step, setStep] = useState(1);
    const formRef = useRef(null);
    const [event, setEvent] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    //parse eid from url and get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                setEvent(response.data);
                setLoading(false);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    //scroll to top on step change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step])

    const { i18n } = useTranslation('common');

    function submit(e) {
        e.preventDefault();

        setLoading(true);
        const submission = new FormData(e.target);

        if (!props.fullUser || !props.fullUser.user) {
            alert("Please login to register");
            return;
        }
        if (props.fullUser.user.role === "admin"){
            alert("Les administrateurs ne peuvent pas s'inscrire à un événement");
            return;
        }

        submission.append("deletedProjets", JSON.stringify(deletedProjets));
        submission.append("projets", JSON.stringify(projets));
        for (let i = 0; i < projets.length; i++) {
            for (let j = 0; j < projets[i].files.length; j++) {
                submission.append("file_" + projets[i]._id + "_" + j, projets[i].files[j]);
            }
        }
        submission.append("userId", props.fullUser.user._id);
        submission.append("eventId", event._id);

        api.saveSDE24popB(submission).then((response) => {
            console.log("response.data")
            console.log(response.data)
            setLoading(false);
            if (response.data === "success") {
                setPopupOpen(true);
            } else {
                alert("error")
            }
        });
    }

    function nextStep() {
        if (step === 1 && validateStep1()) {
            setStep(step + 1);
        }
        if (step === 2 && validateStep2()) {
            setStep(step + 1);
        }
        if (step === 3 && validateStep3()) {
            setStep(step + 1);
        }
    }

    function validateStep1() {
        const form = new FormData(formRef.current);
        return validateStep1BSDE2024(form, projets);
    }


    function validateStep2() {
        const form = new FormData(formRef.current);
        return validateStep2SDE2024(form);
    }

    function validateStep3() {
        const form = new FormData(formRef.current);
        if (form.has("compris_confidentialite") && form.has("compris_frais")) {
            return true;
        } else {
            alert("Veuillez cocher toutes les cases");
            return false;
        }
    }

    if (loading) {
        return <Section className="padding"><Spinner/></Section>
    }

    return (<>
        <Header />
        <form onSubmit={submit} ref={formRef}>
            <Section className="padding" style={{ display: step === 1 ? 'block' : 'none' }}>
                <PopB1 projets={projets} setDeletedProjets={setDeletedProjets} setProjets={setProjets}/>
            </Section>
            <Section className="padding" style={{ display: step === 2 ? 'block' : 'none' }}>
                <Step2 pop={"b"} />
            </Section>
            <Section className="padding" style={{ display: step === 3 ? 'block' : 'none' }}>
                <H1>{i18n.language === "fr" ? "Validation de l'inscription" : "Registration validation"}</H1>
                <p>{i18n.language === "fr" ? "Afin de garantir la confidentialité des informations de chaque projet, un accord de confidentialité entre votre société et le VIA doit être signé en amont de l’événement." : "In order to guarantee the confidentiality of the information for each project, a confidentiality agreement between your company and the VIA must be signed before the event."}</p>
                <br /><br />
                <label className="centered"><input type="checkbox" name="compris_confidentialite" required /><span>{i18n.language === "fr" ? "J’ai compris *" : "I understand *"}</span></label><br /><br />
                <strong>{i18n.language === "fr" ? "Frais de participation :" : "Participation fees:"}</strong><br />
                <p>{i18n.language === "fr" ? "Frais de participation : 60 € HT par rendez-vous confirmé (adhérents Ameublement français, cotisants CODIFAB : - 25%). Les frais de participation sont à régler lorsque la liste de vos rendez-vous vous est adressée (un lien vous sera envoyé à cet effet). Sans paiement des frais en amont de l'évènement, l'accès à l'évènement pourra vous être refusé." : "Participation fees: 60 € excl. VAT per confirmed appointment (French Furniture Association members, CODIFAB contributors: - 25%). Participation fees are to be paid when the list of your appointments is sent to you (a link will be sent to you for this purpose). Without payment of the fees before the event, access to the event may be refused."}</p>
                <br />
                <label className="centered"><input type="checkbox" name="compris_frais" required /><span>{i18n.language === "fr" ? "J’ai compris *" : "I understand *"}</span></label><br /><br />
            </Section>
            <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '40px' }}>
                {step > 1 && <BlueButton onClick={(e) => { e.preventDefault(); setStep(step - 1) }}>{i18n.language === "fr" ? "Précédent" : "Previous"}</BlueButton>}
                {step < 3 && <BlueButton onClick={(e) => { e.preventDefault(); nextStep() }}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Suivant" : "Next"}</BlueButton>}
                {step === 3 && <input type="submit" value={i18n.language === "fr" ? "Enregistrer" : "Save"} />}
            </Section>
        </form>
        {popupOpen &&
            <Popup>
                <span>{i18n.language === "fr" ? "N'oubliez-pas de prioriser vos choix d'architectes, architectes d'intérieurs, prescripteurs, donneurs d'ordre, pour finaliser votre inscription." : "Don't forget to prioritize your choices of architects, interior designers, specifiers, principals, to finalize your registration."}</span><br/>
                <BlueButton onClick={() => navigate("/evenements")}>{i18n.language === "fr" ? "Fermer" : "Close"}</BlueButton>
            </Popup>
        }
    </>)
}

export default RegisterSDE24popB;